import { add, differenceInCalendarDays, parseISO, startOfDay } from 'date-fns';
import { useCallback } from 'react';

export type InstallmentOption = {
  value: string;
  label: string;
  valueOption?: string;
};

export const calculateDaysRemaining = (endDate) => {
  // Converter a string de data final para um objeto Date
  const end = startOfDay(new Date(endDate));
  const now = startOfDay(new Date());

  const daysRemaining = differenceInCalendarDays(end, now);

  return daysRemaining;
};
export const calculateEndDate = (activationDate, planType) => {
  let monthsToAdd;

  switch (planType) {
    case 'yearly':
      monthsToAdd = 12;
      break;
    case 'biennale':
      monthsToAdd = 24;
      break;
    case 'thirtythreemonths':
      monthsToAdd = 33;
      break;
    case 'triennial':
      monthsToAdd = 36;
      break;
    case 'thirtyfourmonths':
      monthsToAdd = 34;
      break;
    case 'thirtymonths':
      monthsToAdd = 30;
      break;
    case 'quarterly':
      monthsToAdd = 3;
      break;
    case 'monthly':
      monthsToAdd = 1;
      break;
    case 'sevenDays':
      monthsToAdd = 0;
      break;
    case 'extsevenDays':
      monthsToAdd = 0;
      break;
    case 'twentyTwoDays':
      monthsToAdd = 0;
      break;
    default:
      throw new Error('Tipo de plano desconhecido');
  }

  // Usando o método `add` para adicionar os meses à data de ativação
  const endDateObj = add(new Date(activationDate), { months: monthsToAdd });

  // Formatar a data final como uma string no formato 'YYYY-MM-DD'
  const year = endDateObj.getFullYear();
  const month = String(endDateObj.getMonth() + 1).padStart(2, '0'); // Os meses começam em 0
  const day = String(endDateObj.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const calculateTotalCharge = (multePlanValue, fields) => {
  const multePlanValueNumber = parseFloat(multePlanValue);
  const totalMultaDetran = fields.reduce((acc, curr) => {
    let valueWithoutCurrency = curr.value.replace('R$ ', '').replace(/\./g, '');
    valueWithoutCurrency = valueWithoutCurrency.replace(',', '.');
    const valueNumber = parseFloat(valueWithoutCurrency);
    return acc + (isNaN(valueNumber) ? 0 : valueNumber);
  }, 0);
  return (multePlanValueNumber + totalMultaDetran).toFixed(2);
};

export const calculateNewPaymentAmount = (payment) => {
  const today = new Date();
  const dueDate = parseISO(payment.dueDate);
  const daysOverdue = differenceInCalendarDays(today, dueDate);

  let newValue = payment.value;
  if (daysOverdue > 0) {


    if (payment.fine && payment.fine.type === "PERCENTAGE") {
      const fineAmount = (payment.value * payment.fine.value) / 100;
      newValue += fineAmount;
    }

    // Aplica juros diários, se definidos
    // Aplica juros diários, se definidos
    if (payment.interest && payment.interest.type === "PERCENTAGE") {
      const monthlyInterestRate = payment.interest.value;
      const dailyInterestRate = (monthlyInterestRate / 100) / 30;  // Divide o percentual mensal por 30
      const totalInterest = dailyInterestRate * payment.value * daysOverdue;
      newValue += totalInterest;
    }
  }
  return newValue;  // Retorna apenas o novo valor

};

// Função auxiliar para truncar a hora, deixando apenas a data
export const truncateDate = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const useCalculateInstallmentOptions = () => {
  return useCallback((totalValue: number, maxInstallments: number): InstallmentOption[] => {
    if (totalValue === 0) return [];

    const options: InstallmentOption[] = [
      { value: "", label: "-" }
    ];

    // Adiciona a opção de 1 parcela, mesmo que o valor seja menor que R$ 50
    options.push({
      valueOption: totalValue.toFixed(2),
      label: `1 x R$ ${totalValue.toFixed(2)}`,
      value: "1",
    });

    // Adiciona as outras opções de parcelamento, se o valor da parcela for maior ou igual a R$ 50
    for (let i = 2; i <= maxInstallments; i++) {
      const installmentValue = totalValue / i;
      if (installmentValue >= 50) {
        options.push({
          valueOption: installmentValue.toFixed(2),
          label: `${i} x R$ ${installmentValue.toFixed(2)}`,
          value: i.toString(),
        });
      }
    }

    return options;
  }, []);
};